/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import { formatReceived } from 'utils/formatValues';
import Table from 'components/Table';
import { getRiesgosDePuestos } from 'api/catalogos';
import { checkToken } from 'api/utils';

export const riesgopuestonominaPermission = {
  permissionModel: 'riesgopuestonomina',
  catalogsModels: [],
  tabsModels: [],
};

const RiesgoPuesto = ({ permission }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _data,
      ] = await Promise.all([
        getRiesgosDePuestos(),
      ]);
      if (mounted) {
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 100,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 400,
    },
    {
      titleText: 'Vigencia Inicial',
      dataIndex: 'inicio_de_vigencia',
      key: 'inicio_de_vigencia',
      width: 200,
      render: (val) => val?.format(),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'fin_de_vigencia',
      key: 'fin_de_vigencia',
      width: 200,
      render: (val) => val?.format(),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          permission={permission}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default RiesgoPuesto;
